import {
  NhanVienEntity,
  PhongBanEntity,
  PhongHopEntity,
} from '../../../../../server-api-hrm.type'
import { BASE_URL } from '../../../../../utils/config.base-url'

export const PHIEU_DAT_PHONG_HOP_PREFIX_URL = '/phieu-dat-phong-hop'

export const PHIEU_DAT_PHONG_HOP_WAITING_APPROVAL_PREFIX_URL = `${PHIEU_DAT_PHONG_HOP_PREFIX_URL}/waiting-approval`
export const PHIEU_DAT_PHONG_HOP_APPROVED_PREFIX_URL = `${PHIEU_DAT_PHONG_HOP_PREFIX_URL}/approved`
export const PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL = `${PHIEU_DAT_PHONG_HOP_PREFIX_URL}/report`
export const PHIEU_DAT_PHONG_HOP_CALENDAR_PREFIX_URL = `${PHIEU_DAT_PHONG_HOP_PREFIX_URL}/calendar`

export const URL_ENDPOINT_PHIEU_DAT_PHONG_HOP = `${BASE_URL}/phieu-dat-phong-hop`
export const URL_ENDPOINT_PHIEU_DAT_PHONG_HOP_APPROVAL_LOG = `${BASE_URL}/phieu-dat-phong-hop-approval-log/list/by-phieu-dat-phong-hop`

export interface ReportDataByResource {
  id: string
  rec: PhongHopEntity
  count: number
  percent: number
}

export type ReportNodeByPhongBan =
  | {
      id: string
      isParent: true
      rec: PhongBanEntity
      count: number
      percent: number
      children: (ReportNodeByPhongBan & { isParent: false })[]
    }
  | {
      id: string
      isParent: false
      rec: NhanVienEntity
      count: number
      percent: number
      children?: undefined
    }

export type ReportDataByPhongBan = ReportNodeByPhongBan & { isParent: true }
